export const TRANSLATIONS_SV = {
  "routes_Pages": "Sidor",
  "routes_Dashboard": "Administrationspanel",
  "routes_Questionnaire": "Standarder",
  "routes_Stats": "Statistik",
  "routes_Settings": "Inställningar",
  "routes_Resouces": "Resurser",
  "routes_Contact": "Kontakt",
  "routes_Downloads": "Nerladdningar",
  "routes_Documentation": "Dokumentation",
  "dashboard_welcome_message": "Välkommen till Accessibility Management System Administrationspanel 👋",
  "dashboard_label": "All din tillgänglighetsdata samlad, strukturerad och övervakad på ett ställe.",
  "gettingStartedCard_gettingStarted": "Kom igång",
  "gettingStartedCard_gettinStartedDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam elementum dui nunc, ac porta sem consequat nec. Pellentesque",
  "gettingStartedCard_Steps": "Vi rekommenderar dessa steg till att börja med:",
  "gettingStartedCard_step1": "Läs dokumentationen",
  "gettingStartedCard_step2": "Ladda ner Checklistan",
  "gettingStartedCard_step3": "Kolla din statistik",
  "companyCard_supportedStandards": "Standarder som stöds:",
  "companyCard_companyInformation": "Företagsinformation",
  "companyCard_numberOfEmployees": "anställda",
  "propertyListPage_propertyList": "Anläggningsförteckning",
  "propertyListPage_dashboard": "Instrumentpanel",
  "propertyListPage_Questionnaire": "Standarder",
  "propertyListPage_newProperty": "Ny Anläggning",
  "propertyListPage_textmapEdit": "Redigera anläggning",
  "propertyListPage_textmapQuestionnaire": "Klassificera",
  "propertyListPage_textmapFacility": "Redigera facilitet",
  "propertyListPage_textmapNewProperty": "Ny anläggning",
  "propertyListPage_createNewProperty": "Skapa ny anläggning",
  "propertyListPage_disabilityClassification": "Tillgänglighetsklassificering",
  "propertyListPage_editProperty": "Redigera anläggning",
  "propertyListPage_editFacilities": "Redigera facilitet",
  "propertyListPage_classify": "Klassificera",
  "propertyListPage_search": "Sök efter anläggningens namn",
  "propertyForm_propertyInformation": "1.1 Anläggningsinformation",
  "propertyForm_standardType": "Standardtyp",
  "propertyForm_fieldCannotBeChanged": "Detta fält kan inte ändras",
  "propertyForm_propertyCategory": "Anläggningskategori",
  "propertyForm_typeOfProperty": "Typ av anläggning",
  "propertyForm_propertyName": "Anläggningens namn",
  "propertyForm_propertyArea": "Antal kvadratmeter golvyta",
  "propertyForm_enterPropertyAddress": "1.1.2 Ange anläggningsadress",
  "propertyForm_addressLocation": "Ange adressplatsen nedan",
  "propertyForm_mapNote": "Om det behövs kan du justera kartan så att nålen är på rätt plats",
  "propertyForm_keyPropertyData": "1.2 Viktiga fastighetsdata",
  "propertyForm_floorsQuestion": "Hur många våningsplan har din anläggning?",
  "propertyForm_roomsQuestion": "Hur många rum har din anläggning?",
  "propertyForm_disabledRoomsQuestion": "Hur många tillgänglighetsanpassade rum har din anläggning?",
  "propertyForm_alergyRoomsQuestion": "Hur många allergirum har din anläggning?",
  "propertyForm_save": "Spara",
  "propertyForm_propertyHotelTypeOptionsLabel_Hotel": "Hotell",
  "propertyForm_propertyHotelTypeOptionsLabel_Motel": "Motell",
  "propertyForm_propertyConvenienceStoreOptions_Candies": "Godis",
  "propertyForm_propertyConvenienceStoreOptions_Newspapers": "Tidningar",
  "propertyForm_propertyConvenienceStoreOptions_TobaccoProducts": "Tobaksaffär",
  "propertyForm_propertyConvenienceStoreOptions_Toiletries": "Toalettartiklar",
  "propertyForm_propertyConvenienceStoreOptions_Store": "Affär",
  "propertyForm_propertyConvenienceStoreOptions_Supermarket": "Mataffär",
  "propertyForm_propertyDepartmentStoreOptions_Clothing": "Kläder",
  "propertyForm_propertyDepartmentStoreOptions_DepartmentStore": "Varuhus",
  "propertyForm_propertyDepartmentStoreOptions_Electronics": "Elektronik",
  "propertyForm_propertyDepartmentStoreOptions_Garden": "Trädgård",
  "propertyForm_propertyDepartmentStoreOptions_Household_goods": "Hushållsartiklar",
  "propertyForm_propertyDepartmentStoreOptions_Pets": "Husdjur",
  "propertyForm_propertyDepartmentStoreOptions_Toys": "Leksaker",
  "propertyForm_propertyFoodAndDrinkOptions_bakery_and_baked_goods_store": "Bageri och bakverk",
  "propertyForm_propertyFoodAndDrinkOptions_dairy_goods": "Mejerivaror",
  "propertyForm_propertyFoodAndDrinkOptions_food_and_drink": "Mat och dryck",
  "propertyForm_propertyFoodAndDrinkOptions_food_beverage_specialty_store": "Specialaffär för mat dryck",
  "propertyForm_propertyFoodAndDrinkOptions_grocery": "Matvaror",
  "propertyForm_propertyFoodAndDrinkOptions_meat": "Kött",
  "propertyForm_propertyFoodAndDrinkOptions_specialty_food_store": "Specialkost affär",
  "propertyForm_propertyFoodAndDrinkOptions_Vegan": "Veganskt",
  "propertyForm_propertyFoodAndDrinkOptions_Vegetarian": "Vegetariskt",
  "propertyForm_propertyFoodAndDrinkOptions_wine_and_liquor": "Vin och alkohol",
  "propertyForm_propertyDrugstoreOptions_drugstore": "Apotek",
  "propertyForm_propertyDrugstoreOptions_pharmacy": "Apotek",
  "propertyForm_propertyElectronicsOptions_computer_and_software": "Dator och mjukvara",
  "propertyForm_propertyElectronicsOptions_consumer_electronics_store": "Elektronikvaruhus",
  "propertyForm_propertyElectronicsOptions_electronics": "Elektronik",
  "propertyForm_propertyElectronicsOptions_entertainment_electronics": "Underhållningselektronik",
  "propertyForm_propertyElectronicsOptions_mobile_retailer": "Mobilåterförsäljare",
  "propertyForm_propertyElectronicsOptions_mobile_service_center": "Mobilservice",
  "propertyForm_propertyMallOptions_shopping_gallery_mall": "Shoppinggalleria",
  "propertyForm_propertyMallOptions_shopping_mall": "Shopping centrum",
  "propertyForm_standardTypeOptions_hotel_motel": "Hotell/Motell",
  "propertyForm_standardTypeOptions_shopping_mall": "Shopping centrum",
  "propertyForm_standardTypeOptions_shop": "Butik",
  "propertyForm_propertyHardwareOptions_floor_and_carpet": "Golv och mattor",
  "propertyForm_propertyHardwareOptions_furniture_store": "Möbelvaruhus",
  "propertyForm_propertyHardwareOptions_garden_center": "Trädgårdscenter",
  "propertyForm_propertyHardwareOptions_glass_and_window": "Glas och fönster",
  "propertyForm_propertyHardwareOptions_hardware_house_garden": "Järnvaror hus trädgård",
  "propertyForm_propertyHardwareOptions_home_improvement_hardware_store": "Byggvaruhus",
  "propertyForm_propertyHardwareOptions_home_specialty_store": "Specialbutik för hem",
  "propertyForm_propertyHardwareOptions_lumber": "Virke",
  "propertyForm_propertyHardwareOptions_major_appliance": "Stora vitvaror",
  "propertyForm_propertyHardwareOptions_paint_store": "Färgbutik",
  "propertyForm_propertyHardwareOptions_power_equipment_dealer": "Återförsäljare av kraftutrustning",
  "propertyForm_propertyBookstoreOptions_bookstore": "Bokhandel",
  "propertyForm_propertyClothingOptions_childrens_apparel": "Barnkläder",
  "propertyForm_propertyClothingOptions_clothing_and_accessories": "Kläder och accessoarer",
  "propertyForm_propertyClothingOptions_mens_apparel": "Herrkläder",
  "propertyForm_propertyClothingOptions_shoes_footwear": "Skobutik",
  "propertyForm_propertyClothingOptions_specialty_clothing_store": "Specialklädesaffär",
  "propertyForm_propertyClothingOptions_womens_apparel": "Damkläder",
  "propertyForm_consumerGoodsOptions_adult_shop": "Vuxenbutik",
  "propertyForm_consumerGoodsOptions_arts_and_crafts_supplies": "Tillbehör för konst och hantverk",
  "propertyForm_consumerGoodsOptions_bicycle_and_bicycle_accessories_shop": "Cykel- och cykeltillbehörsbutik",
  "propertyForm_consumerGoodsOptions_camping_hiking_shop": "Friluftsbutik",
  "propertyForm_consumerGoodsOptions_canoe_kayak_shop": "Kanot-och kajakaffär",
  "propertyForm_consumerGoodsOptions_car_accessories": "Biltillbehör",
  "propertyForm_consumerGoodsOptions_consumer_goods": "Konsumtionsvaror",
  "propertyForm_consumerGoodsOptions_cross_country_ski_shop": "Längdskidbutik",
  "propertyForm_consumerGoodsOptions_florist": "Blomsterbutik",
  "propertyForm_consumerGoodsOptions_general_merchandise": "Allmänna varor",
  "propertyForm_consumerGoodsOptions_gift_antique_art": "Presenter antikt konst",
  "propertyForm_consumerGoodsOptions_hobby_store": "Hobbybutik",
  "propertyForm_consumerGoodsOptions_hunting_fishing_shop": "Jägar- och fiskebutik",
  "propertyForm_consumerGoodsOptions_jeweler": "Juvelerare",
  "propertyForm_consumerGoodsOptions_market": "Marknad",
  "propertyForm_consumerGoodsOptions_motorcycle_accessories": "Motorcykeltillbehör",
  "propertyForm_consumerGoodsOptions_non_store_retailers": "Återförsäljare som inte är butiker",
  "propertyForm_consumerGoodsOptions_office_supply_store": "Kontorsmaterial",
  "propertyForm_consumerGoodsOptions_pawnshop": "Pantbank",
  "propertyForm_consumerGoodsOptions_pet_supply": "Djuraffär",
  "propertyForm_consumerGoodsOptions_record_cd_video": "Musik- och videobutik",
  "propertyForm_consumerGoodsOptions_running_walking_shop": "Löpning och promenadbutik",
  "propertyForm_consumerGoodsOptions_skate_shop": "Skatebutik",
  "propertyForm_consumerGoodsOptions_ski_snowboard_shop": "Skid- och snowboardbutik",
  "propertyForm_consumerGoodsOptions_specialty_store": "Specialaffär",
  "propertyForm_consumerGoodsOptions_sporting_goods_store": "Sportaffär",
  "propertyForm_consumerGoodsOptions_surf_shop": "Surfbutik",
  "propertyForm_consumerGoodsOptions_tack_shop": "Ridsportbutik",
  "propertyForm_consumerGoodsOptions_toy_store": "Leksaksaffär",
  "propertyForm_consumerGoodsOptions_used_second_hand_merchandise_stores": "Begagnade second hand handelsvarubutiker",
  "propertyForm_consumerGoodsOptions_variety_store": "Lågprisbutik",
  "propertyForm_consumerGoodsOptions_video_and_game_rental": "Video- och speluthyrning",
  "propertyForm_consumerGoodsOptions_warehouse_wholesale_store": "Lagergrossistbutik",
  "propertyForm_hairAndBeautyOptions_barber": "Barberare",
  "propertyForm_hairAndBeautyOptions_hair_and_beauty": "Hår och skönhet",
  "propertyForm_hairAndBeautyOptions_hair_salon": "Hårsalong",
  "propertyForm_hairAndBeautyOptions_nail_salon": "Nagelsalong",
  "propertyForm_hairAndBeautyOptions_make_up_salon": "Sminksalong",
  "propertyForm_mallTopCategoryOptions_mall_shopping_complex": "Köpcentrumkomplex",
  "propertyForm_accomodationsCategoryOptions_hotel_motel": "Hotell/Motell",
  "propertyForm_shopCategoryOptions_convenience_store": "Närbutik",
  "propertyForm_shopCategoryOptions_department_store": "Varuhus",
  "propertyForm_shopCategoryOptions_food_and_drink": "Mat och dryck",
  "propertyForm_shopCategoryOptions_drugstore_or_pharmacy": "Apotek",
  "propertyForm_shopCategoryOptions_electronics": "Elektronik",
  "propertyForm_shopCategoryOptions_hardware_house_garden": "Järnvaror hus trädgård",
  "propertyForm_shopCategoryOptions_bookstore": "Bokhandel",
  "propertyForm_shopCategoryOptions_clothing_and_accessories": "Kläder och accessoarer",
  "propertyForm_shopCategoryOptions_consumer_goods": "Konsumtionsvaror",
  "propertyForm_shopCategoryOptions_hair_and_beauty": "Hår och skönhet",
  "facilitiesForm_standardTypeOptions_hotel_motel": "Hotell/Motell",
  "facilitiesForm_standardTypeOptions_office": "Kontor",
  "facilitiesForm_standardTypeOptions_shopping_mall": "Shopping centrum",
  "facilitiesForm_standardTypeOptions_shop": "Butik",
  "facilitiesForm_selectFacilitiesForDataCollection": "2. Välj faciliteter för datainsamling",
  "facilitiesForm_preselectedMandatoryItems": "Följande förvalda punkter är obligatoriska",
  "facilitiesForm_mandatoryFacilitiesFor": "Obligatoriska faciliteter för",
  "facilitiesForm_optionalFacilitiesFor": "Valfria faciliteter för",
  "facilitiesForm_standard": "Standard",
  "facilitiesForm_preselectedOptionalItems": "Följande punkter är valfria",
  "facilitiesForm_faq_mandatoryFacilities": "Vad är obligatoriska faciliteter?",
  "facilitiesForm_faq_AnswerMandatoryFacilities": "Det är standardfaciliteter som vi hittar i anläggningar av ditt slag. För att generera vår tillgänglighetsdata på ett grundligt sätt måste dessa faciliteter bedömas. T.ex ingången till byggnaden",
  "facilitiesForm_faq_optionalFacilities": "Vad är valfria faciliteter?",
  "facilitiesForm_faq_AnswerOptionalFacilities": "Detta är en icke-uttömmande lista över faciliteter som kan - eller inte kan finnas på din anläggning, men som inte nödvändigtvis är standardfaciliteter på en anläggning som din. Till exempel ett spa på ett hotell eller i ett köpcentrum.",
  "unitForm_helperText_entrance_key": "Ingång",
  "unitForm_helperText_entrance_value": "dvs huvudingång eller sekundära ingångar såsom via restaurang eller trädgård",
  "unitForm_helperText_lobby_key": "Lobby",
  "unitForm_helperText_lobby_value": "dvs huvudlobbyn på anläggningen inklusive lounge eller väntrum",
  "unitForm_helperText_reception_key": "Reception/informationsdisk",
  "unitForm_helperText_reception_value": "dvs incheckningsdisk, bagageförvaring eller informationsdisk",
  "unitForm_helperText_facility_key": "Facilitet",
  "unitForm_helperText_facility_value": "",
  "unitForm_helperText_parking_key": "Parkering och nära omgivningar",
  "unitForm_helperText_parking_value": "d.v.s. parkeringsområde och ytterligare utomhusområden som trädgårdar, uppfarter, gångvägar",
  "unitForm_helperText_commonAreas_key": "Allmänna utrymmen",
  "unitForm_helperText_commonAreas_value": "Gemensamma allmänna utrymmen på hotellet såsom lobby, lounge, korridorer etc.",
  "unitForm_helperText_conferenceRoom_key": "Konferensrum / mötesrum",
  "unitForm_helperText_conferenceRoom_value": "",
  "unitForm_helperText_auditorium_key": "Hörsal",
  "unitForm_helperText_auditorium_value": "Teaterliknande plats, biograf etc.",
  "unitForm_helperText_diningArea_key": "Matplats",
  "unitForm_helperText_diningArea_value": "t.ex. restaurang, frukostbufféområde, lobby-bar/bistro",
  "unitForm_helperText_toiletRoom_key": "Toalettrum (gemensam)",
  "unitForm_helperText_toiletRoom_value": "d.v.s. gemensam toalett/badrum tillgängligt från lobbyn, restaurangen eller andra allmänna utrymmen",
  "unitForm_helperText_gym_key": "Gym",
  "unitForm_helperText_gym_value": "",
  "unitForm_helperText_spa_key": "Spa",
  "unitForm_helperText_spa_value": "",
  "unitForm_helperText_hospitalityRoom_key": "Typ av hotellrum",
  "unitForm_helperText_hospitalityRoom_value": "d.v.s. Typ av rum, t.ex. Enkel, dubbel, tillgänglig, familj mm.",
  "unitForm_quantityLabel": "Välj kvantitet",
  "unitForm_locationFaq": "Var ligger den?",
  "unitForm_totalQuantity": "Total kvantitet",
  "unitForm_floorSelection": "Väj våningsplan",
  "unitForm_finishedCreation": "Är du klar med att skapa enheter?",
  "unitForm_startClassifying": "Frågeformulär!",
  "unitForm_unitData2": "Privat toalett",
  "unitForm_unitData3": "Privat badrum",
  "unitForm_unitData4": "Privat kök",
  "unitForm_unitTypeDetails": "3. Information om enhetstyp:",
  "unitForm_unitName": "Skriv enhetens namn här",
  "unitForm_accessibleUnit": "Denna enhet anses vara tillgänglig",
  "questionUnits_addNewUnit": "Lägg till ny enhet",
  "questionUnits_savedInfo": "Din information sparades",
  "questionUnits_removedInfo": "Din information togs bort",
  "questionUnits_resources": "Resurser",
  "questionUnits_uploadPictures": "Ladda upp Bilder",
  "questionUnits_explanation": "Vissa förklaringar / detaljer om detta avsnitt kan gå här",
  "questionUnits_uploadLabel": "LADDA UPP",
  "questionUnits_unitExtraInfo": "Enhet Extra info",
  "questionUnits_unitExtraInfoPlaceholder1": "Här kan du infoga privata kommentarer till denna specifika enhet",
  "questionUnits_unitExtraInfoPlaceholder2": "(för närvarande har du inga kommentarer om denna enhet)",
  "questionUnits_beforeClassification": "Du bör lägga till faciliteter innan du börjar klassificera",
  "questionUnits_editFacilities": "Redigera faciliteter",
  "questionUnits_addNew": "Klicka på \"Lägg till ny\" eller välj enhet för att börja klassificera",
  "questionUnits_faq1": "Info",
  "questionUnits_faq2": "Vad är obligatoriska faciliteter?",
  "questionUnits_faq2_1": "Det är standardfaciliteter som vi hittar på anläggningar av ditt slag. För att generera vår tillgänglighetsdata på ett grundligt sätt måste dessa faciliteter bedömas. Ex. ingången till byggnaden",
  "questionUnits_faq3": "Vad är valfria faciliteter?",
  "questionUnits_faq3_1": "Detta är en icke-uttömmande lista över faciliteter som kan - eller inte kan finnas på din anläggning, men som inte nödvändigtvis är standardfaciliteter på en anläggning som din. Till exempel ett spa på ett hotell eller i ett köpcentrum.",
  "FAR_SelectProperty": "Välj anläggning",
  "FAR_DocumentPreview": "Dokumentförhandsgranskning:",
  "FAR_DownloadPDF": "Ladda ner PDF:",
  "FAR_Download": "Ladda ner nu!",
  "CLP_SelectProperty": "Välj anläggning",
  "CLP_SelectPropertyForChecklist": "Välj en anläggning för att skapa checklistan",
  "CLP_AccessibilityChecklist": "Tillgänglighets checklista",
  "CLP_GeneratedOn": "Genererad på ",
  "CLP_GeneratedBy": "Genererad av ",
  "CLP_LoadingDoc": "Laddar dokument...",
  "CLP_DownloadNow": "Ladda ner nu!",
  "A11yUnitsPageSubTitle": "Saker att tänka på",
  "A11yUnitsPageDescription": "Du kan bara associera enheter som liknar varandra om de är exakt likadana. Annars bör en annan enhetstyp skapas.",
  "routes_NewProperty": "Ny Anläggning",
  "routes_EditProperty": "Redigera Anläggning",
  "routes_EditFacility": "Redigera Facilitet",
  "routes_SelectFacilities": "Välj Faciliteter",
  "routes_CreateProperty": "Skapa Anläggning",
  "routes_Classify": "Klassificera",
  "routes_Blank": "Blank",
  "changePassword_success": "Genomfört",
  "changePassword_successMessage": "Ditt lösenord har uppdaterats",
  "changePassword_returnToLogin": "Gå tillbaka till inloggning",
  "changePassword_resetPassword": "Återställ ditt lösenord",
  "changePassword_newPassword_label": "Nytt Lösenord",
  "changePassword_confirmNewPassword_label": "Bekräfta nytt lösenord",
  "changePassword_newPasswordRequired_errorMessage": "Nytt lösenord krävs",
  "changePassword_newPasswordMismatch_errorMessage": "Passwords must match",
  "changePassword_newPassword_browserTab": "Byt lösenord",
  "DocumentationPage_pageTitle": "Dokumentationssida",
  "DocumentationPage_tabtitle": "Dokumentation",
  "DownloadsPage_pageTitle": "Nedladdningssida",
  "LanguagesDropdown_English": "Engelska",
  "LanguagesDropdown_French": "Franska",
  "LanguagesDropdown_German": "Tyska",
  "LanguagesDropdown_Dutch": "Holländska",
  "LocationAutocomplete_searchPlaceholder": "Sök platser ...",
  "LocationAutocomplete_validAddress": "Vänligen ange husnummer och gata",
  "LocationAutocomplete_addressEmpty": "Adressen får inte vara tom",
  "page404_PageNotFound": "Sidan hittades inte.",
  "page404_PageNotFound_explanation": "Sidan du letar efter kan ha tagits bort.",
  "page404_PageNotFound_returnHome_button": "Gå tillbaka till hemsidan",
  "page500_InternalError": "Internt serverfel.",
  "page500_InternalError_explanation": "The server encountered something unexpected that didn't allow it to complete the request.",
  "propertyListPage_NotClassified": "Inte Klassificerad",
  "propertyListIconName_allergy_food_class": "Allergi Mat Klass",
  "propertyListIconName_allergy_room_class": "Allergi Rums Klass",
  "propertyListIconName_mobility_class": "Mobilitet Klass",
  "propertyListIconName_hearing_class": "Hörsel Klass",
  "propertyListIconName_cognitive_class": "Kognitiv Klass",
  "propertyListIconName_visual_class": "Visuell Klass",
  "propertyForm_AllStepsCompleted": "Alla steg genomförda",
  "propertyForm_propertyReady": "Din anläggning är nu klar!",
  "propertyForm_propertyReady_description": "Du har avslutat steget med din anläggningsinformation. Du kan redigera denna information genom att klicka på länken Anläggningsförteckning i den övre vänstra panelen.",
  "propertyForm_startClassifying": "BÖRJA KLASSIFICERA",
  "propertyForm_propertyStepper_step1": "Lägg till Anläggningsinformation",
  "propertyForm_propertyStepper_step2": "Välj Faciliteter",
  "propertyForm_propertyStepper_step3": "Lägg till enhetsdetaljer",
  "settingsForms_CompanyInformation_SelectOptions_Service": "Service",
  "settingsForms_CompanyInformation_SelectOptions_Merchandising": "Handelsvaror",
  "settingsForms_CompanyInformation_SelectOptions_Manufacturing": "Tillverkning",
  "settingsForms_CompanyInformation_SelectOptions_Other": "Övrigt",
  "settingsForms_ImageCantBeChanged": "Den här bilden kan inte ändras",
  "settingsForms_RegNumber_label": "Organisationsnummer",
  "settingsForms_InvoiceStatus_label": "Fakturastatus",
  "settingsForms_CompanyName_label": "Företagsnamn",
  "settingsForms_CompanyType_label": "Företagstyp",
  "settingsForms_CompanySize_label": "Företagsstorlek",
  "settingsForms_CompanyAddress_label": "Företags Adress",
  "settingsForms_ContractDate_label": "Datum för undertecknande av kontrakt",
  "settingsForms_SubscriptionPeriod_label": "Prenumerationsperiod",
  "settingsForms_Employees_label": "Anställda",
  "settingsForms_UserInformation_positionOptions_owner": "Ägare",
  "settingsForms_UserInformation_positionOptions_executive": "Direktör",
  "settingsForms_UserInformation_positionOptions_manager": "Chef",
  "settingsForms_UserInformation_positionOptions_operations_and_production": "Drift och produktion",
  "settingsForms_UserInformation_positionOptions_other": "Annat",
  "settingsForms_UserInformation_departmentOptions_it": "IT",
  "settingsForms_UserInformation_departmentOptions_marketing": "Marknadsföring",
  "settingsForms_UserInformation_departmentOptions_finance": "Finans",
  "settingsForms_UserInformation_departmentOptions_human_resources": "Personalavdelning",
  "settingsForms_UserInformation_departmentOptions_sales": "Försäljning",
  "settingsForms_UserInformation_departmentOptions_operations": "Operationer",
  "settingsForms_UserInformation_departmentOptions_other": "Annat",
  "settingsForms_UserInformation_title": "Användar information",
  "settingsForms_UserInformation_UploadPicture": "Ladda upp bild",
  "settingsForms_UserInformation_formatRestriction": "Använd en bild på minst 128px x 128px i .jpg-format",
  "settingsForms_UserInformation_surname": "Efternamn",
  "settingsForms_UserInformation_position": "Position",
  "settingsForms_UserInformation_department": "Avdelning",
  "settingsPage_pageTitle": "Inställningssida",
  "settingsPage_breadcrumbs_dashboard": "Administrationspanel",
  "settingsPage_breadcrumbs_settings": "Inställningar",
  "signinForm_explanation": "Logga in på ditt konto för att fortsätta",
  "signinForm_validEmail_error": "Måste vara en giltig e-post",
  "signinForm_emailRequired": "E-post krävs",
  "signinForm_generalError": "Något gick fel",
  "signinForm_passwordRequired": "Lösenord krävs",
  "signinForm_emailLabel_textfield": "E-postadress",
  "signinForm_passwordLabel_textfield": "Lösenord",
  "signinForm_remberMeCheckbox_textfield": "Kom ihåg mig",
  "signinForm_signIn_button": "Logga in",
  "signinForm_forgotPassword_button": "Glömt ditt lösenord",
  "signupForm_signUp_button": "Gå Med",
  "signupForm_signUp_title": "Kom ingång",
  "signupForm_signUp_subTitle": "Börja skapa den bästa möjliga användarupplevelsen för dina kunder",
  "signupForm_signUp_nameRequired": "Namn krävs",
  "signupForm_signUp_minCharacters_errorMessage": "Måste vara minst 12 tecken",
  "signupForm_signUp_required_errorMessage": "Nödvändig",
  "signupForm_signUp_nameLabel": "Namn",
  "signupForm_signUp_companyLabel": "Företag",
  "signupForm_signUp_emailAddressLabel": "E-postadress",
  "signupForm_signUp_passwordLabel": "Lösenord",
  "signupForm_signUp_confirmPasswordLabel": "Bekräfta lösenord",
  "statsPage_pageTitle": "Statistiksida",
  "statsPage_cardContent": "Den här sidan kommer att finnas tillgänglig i framtida versioner av Accessibility Management Systemet.",
  "resetPassword_inbox": "Kolla din inkorg",
  "resetPassword_explanation_1": "Vi har skickat ett e-post till",
  "resetPassword_explanation_2": "med instruktioner för lösenordsåterställning",
  "resetPassword_title": "Återställ lösenord",
  "resetPassword_subTitle": "Ange din e-post för att återställa ditt lösenord",
  "unitForm_title": "Sammansatta enheter",
  "unitForm_floorTitle": "Våning",
  "unitImagesDialog_labelMANDATORY": "OBLIGATORISK",
  "unitImagesDialog_labelOPTIONAL": "VALFRI",
  "unitImagesDialog_labelPICTURES": "BILDER",
  "unitImagesDialog_dropzone": "Släpp bilder här eller välj en fil",
  "userDropdown_profile": "Profil",
  "userDropdown_signout": "Logga ut",
  "questionUnits_uploadPictures_uploadError": "Ett fel uppstod när bilderna laddades upp",
  "questionUnits_uploadSuccess": "Dina data har skickats in framgångsrikt",
  "questionUnits_unitExtraInfoLabel": "Extra Info",
  "questionUnits_unitExtraInfoDelete_button": "Ta bort",
  "questionUnits_unitExtraInfoSave_button": "Spara",
  "QuestionnaireCompletionCard_title": "Ifyllande av standarder",
  "QuestionnaireCompletionCard_disableMessage": "Du har ingen klassificering ännu.",
  "QuestionnaireCompletionCard_ParkingCard": "Parkering",
  "QuestionnaireCompletionCard_EntranceCard": "Entré",
  "QuestionnaireCompletionCard_ToiletCard": "Toalett",
  "QuestionnaireCompletionCard_RoomsCard": "Rum",
  "QuestionnaireCompletionCard_LiftAndElevatorsCard": "Hissar",
  "QuestionnaireCompletionCard_LobbyAndReceptionCard": "Lobby och reception",
  "FAR_Report": "Tillgänglighetsrapport",
  "FAR_TableUnitName": "Enhetens namn",
  "FAR_TableDescription": "Beskrivning",
  "CLP_PleaseSelectProperty": "Var god och välj anläggning",
  "CLP_BrowserTabTitle": "Fullständig tillgänglighetsrapport",
  "CLP_UnitMandatoryLabel": "Obligatorisk",
  "CLP_UnitDoneLabel": "KLART",
  "propertyPage_Controllers_SearchDoc": "Sök dokumentation",
  "generalWords_Yes": "Ja",
  "generalWords_No": "Nej",
  "generalWords_Next": "Nästa",
  "generalWords_Close": "Stäng",
  "generalWords_Reset": "Återställ",
  "generalWords_Back": "Tillbaka",
  "generalWords_Finish": "Slutför",
  "generalWords_NextStep": "Nästa steg",
  "generalWords_Edit": "Redigera",
  "generalWords_Download": "Ladda ner",
  "generalWords_Delete": "Radera",
  "generalWords_SaveChanges": "Spara Ändringar",
  "generalWords_Selected": "valda",
  "generalWords_Required": "Obligatoriskt",
  "customerSupportPage_title": "Kundsupportsida",
  "customerSupportPage_emailLabel": "Kontakta kundsupport på:",
  "unitForm_helperText_entrance": "dvs huvudingång eller sekundära ingångar såsom via restaurang eller trädgård",
  "unitForm_helperText_lobby": "dvs huvudlobbyn på anläggningen inklusive lounge eller väntrum",
  "unitForm_helperText_reception": "dvs incheckningsdisk, bagageförvaring eller informationsdisk",
  "unitForm_helperText_facility": "d.v.s namnet på anläggningen eller fastigheten.",
  "unitForm_helperText_parking": "d.v.s. parkeringsområde och ytterligare utomhusområden som trädgårdar, uppfarter, gångvägar",
  "unitForm_helperText_conferenceRoom": "Ett konferensrum är ett stort rum där ett antal personer kan ha en konferens.",
  "unitForm_helperText_auditorium": "Teaterliknande plats, biograf etc.",
  "unitForm_helperText_diningArea": "t.ex. restaurang, frukostbuffé-område, lobby-bar/bistro",
  "unitForm_helperText_toiletRoom": "d.v.s. gemensam toalett/badrum tillgängligt från lobbyn, restaurangen eller andra allmänna utrymmen",
  "unitForm_helperText_gym": "Fysiska övningar och aktiviteter som utförs inomhus, ofta med hjälp av utrustning.",
  "unitForm_helperText_spa": "Plats där man kan koppla av genom bastu, pool och jacuzzi.",
  "unitForm_helperText_hospitalityRoom": "d.v.s. Typ av rum, t.ex. Enkel, dubbel, tillgänglig, familj mm.",
  "unitForm_helperText_shopping_aisle": "d.v.s. gång mellan hyllorna",
  "unitForm_helperText_counter": "En plan yta (som ett bord, en hylla eller en monter) var transaktioner genomförs.",
  "unitForm_helperText_checkout_pay": "t.ex. Kassa, Självbetjäning, Självscanning.",
  "unitForm_helperText_fitting_room": "Ett rum i en butik där kunder kan ta på sig ett plagg för att se om det passar innan de köper det.",
  "unitForm_helperText_manned_kiosk": "En kontantväxlings- eller inlösenterminal, som möjliggör kontant- och kontantlösa transaktioner med en kassörska.",
  "unitForm_helperText_floor": "d.v.s tillgängligheten på olika våningar såsom Markplan, Hiss på våning 1, Grön hiss vid entré 2.",
  "unitForm_helperText_playground": "Ett område som används av barn att leka i. Det finns vanligtvis utrustning som rutschkanor, gungor och gungbrädor som barnen kan leka på.",
  "unitForm_helperText_garden": "Ett utrymme, vanligtvis utomhus, avsett för odling, visning och njutning av växter och andra former av natur.",
  "unitForm_helperText_bathroom_common": "Ett rum som innehåller badkar eller dusch och vanligtvis handfat och toalett.",
  "unitForm_helperText_bathroom__private": "Ett privat rum med badkar eller dusch och vanligtvis handfat och toalett.",
  "unitForm_helperText_quiet_room": "Ett rum byggt med hänsyn till tystnad genom att avskärma buller från eller mot omgivningen.",
  "unitForm_helperText_kitchen_common": "Ett offentligt rum där man kan förbereda och laga mat.",
  "unitForm_helperText_toilet_room__private": "d.v.s. privat toalett/badrum tillgängligt från lobbyn, restaurangen eller andra allmänna utrymmen.",
  "unitForm_helperText_kitchen__private": "Ett privat rum där man kan förbereda och laga mat.",
  "unitForm_helperText_conferenceRoom_": "",
  "routes_Services": "Tjänster",
  "routes_Help": "Hjälp",
  "routes_Clp": "Checklista",
  "routes_Far": "Tillgänglighetsrapport",
  "FAR_WhatIsItTitle": "Vad är en tillgänglighetsrapport?",
  "FAR_WhatIsItDescription": "Tillgänglighetsrapport är en rapport som vi genererar åt dig beroende på hur tillgänglig din anläggning är. Nedan kan du välja en anläggning och ladda ner dess PDF-rapport.",
  "FAR_MoreInfo": "För mer information om tillgänglighetsrapporten vänligen",
  "FAR_SelectPropertyForChecklist": "Välj en anläggning för att skapa en rapport",
  "CLP_noChecklistFound": "Vi kunde inte hitta en lista för den här anläggning",
  "CLP_WhatIsItTitle": "Vad är en checklista?",
  "CLP_WhatIsItDescription": "Checklistan är en lista baserad på tillgänglighetssystemets inventeringsinformation. Den visar förbättringsområdena, baserat på din input i systemet. En förhandsgranskning av dokumentet finns tillgänglig och kan laddas ner eller skrivas ut.",
  "CLP_MoreInfo": "För mer information om checklistan vänligen",
  "CLP_FAR_ConsultTheDocumentation": "konsultera dokumentationen",
  "LanguagesDropdown_Swedish": "Svenska",
  "LanguagesDropdown_Danish": "Danska",
  "gettingStartedCard_step1_link": "Läs",
  "gettingStartedCard_step2_link": "Ladda ner",
  "gettingStartedCard_step3_link": "Kolla",
  "contactForm_category": "Kategori",
  "contactForm_title": "Kontakta oss",
  "contactForm_chooseImg": "Välj bild",
  "contactForm_submitBtn": "Skicka förfrågan",
  "contactForm_attachBtnLabel": "Bifoga gärna en skärmdump.",
  "contactForm_messageLabel": "Beskriv vad du efterfrågar här.",
  "contactForm_messageEmptyError": "Vänligen lägg till ett meddelande",
  "contactForm_categoryOptions_ServiceInquiry": "Serviceförfrågan",
  "contactForm_categoryOptions_TechnicalIssues": "Tekniska problem",
  "contactForm_categoryOptions_OtherInquires": "Övriga förfrågningar",
  "contactForm_subtitle1": "Om du inte hittar svaret du letar efter finns vi här för att hjälpa till.",
  "contactForm_subtitle2": "Vänligen skriv till oss! Vi återkommer till dig så snart som möjligt.",
  "FAR_noDataAvalible_1": "Tillgänglighetsrapport kan inte skapas ännu för den här anläggningen. Vänligen gör klart",
  "FAR_noDataAvalible_2": "för",
  "FAR_noDataAvalible_3": "först.",
  "CLP_Updating": "Uppdaterar...",
  "CLP_AreYouSure": "Är du säker?",
  "CLP_UpdateMessage": "Om du gör detta försvinner punkten från checklistan och standarden uppdateras automatiskt genom ändringen.",
  "CLP_Cancel": "AVBRYT",
  "CLP_YesUpdate": "JA, UPPDATERA",
  "CLP_WhatIsAChecklist": "Vad är en checklista?",
  "CLP_Name": "Namn",
  "CLP_pdfDisclaimer": "Obs: När du har gjort förbättringar, glöm då inte att uppdatera din tillgänglighetsinformation i standardavsnittet.",
  "CLP_FAR_noAccessibilityDataAvailable1": "Vi har ingen tillgänglighetsinformation tillgänglig. ",
  "CLP_noChecklist1": "Det går inte att skapa checklistan ännu för den här anläggningen. Svara på frågorna i ",
  "CLP_noChecklist2": "standardavsnitt ",
  "CLP_noChecklist3": "till",
  "CLP_noChecklist4": "först.",
  "CLP_FAR_noAccessibilityDataAvailable2": "Skapa en anläggning",
  "CLP_FAR_noAccessibilityDataAvailable3": " och svara på frågorna i standardavsnitt först.",
  "statsPage_subscriptionExpiring": "Abonnemanget löper ut om",
  "statsPage_days": "dagar",
  "statsPage_contactCustomerSupport": "Kontakta kundsupport",
  "statsPage_companyInformation": "Företagsinformation",
  "statsPage_numberOfPhotosUploaded": "Antal uppladdade foton",
  "statsPage_photos": "foton",
  "statsPage_totalAmountProperties": "Totalt antal anläggningar",
  "statsPage_amountCompleted": "Antal färdigställda",
  "statsPage_actionsPerVisitor": "Åtgärder per besökare på Widgeten",
  "statsPage_yourItems": "Dina objekt",
  "statsPage_name": "Namn",
  "statsPage_sku": "SKU",
  "statsPage_quantity": "Antal",
  "statsPage_numberOfUnits": "Antal enheter",
  "statsPage_accessible": "Tillgängliga",
  "statsPage_notAccessible": "Ej tillgängliga",
  "statsPage_unit": "Enhet",
  "statsPage_amount": "Antal",
  "statsPage_incomplete": "Ofullständig",
  "statsPage_completed": "Färdigställt",
  "statsPage_notCompleted": "Ej färdigställt",
  "statsPage_mobility": "Mobilitet",
  "statsPage_cognitive": "Kognitiv",
  "statsPage_hearing": "Hörsel",
  "statsPage_visual": "Visuell",
  "statsPage_allergy": "Allergi",
  "statsPage_class": "Klass",
  "statsPage_totalAccessibilityDatapoints": "Totala tillgänglighetsdatapunkter",
  "statsPage_visitorsThatOpened": "Besökare som öppnade Widgeten",
  "statsPage_visitorsInteraction": "Totalt antal åtgärder på Widgeten",
  "statsPage_action": "Handling",
  "statsPage_clicks": "Klickar",
  "statsPage_noDataAvailable_topText": "Det finns ingen data tillgänglig",
  "statsPage_noDataAvailable_bottomText": "För tillfället",
  "statsPage_company_address": "Adress",
  "statsPage_company_city": "Stad",
  "statsPage_company_country": "Land",
  "statsPage_company_name": "Namn",
  "statsPage_company_type": "Typ",
  "statsPage_company_registration_number": "Registreringsnummer",
  "statsPage_company_logo": "Logotyp",
  "statsPage_company_employees": "Medarbetare",
  "statsPage_company_empty_fields": "Tomma fält",
  "settingsPage_alertMsgImageUpload": "Klicka på spara för att uppdatera din profilbild",
  "settingsPage_alertMsgCompanyInformation_1": "Kontakta",
  "settingsPage_alertMsgCompanyInformation_2": "Kundsupport",
  "settingsPage_alertMsgCompanyInformation_3": "om du behöver göra ändringar i företagsinformationen.",
  "documentationPage_downloadDocument": "Ladda ner dokumentet",
  "documentationPage_loadingDocument": "Laddar dokumentet",
  "CLP_Status": "Status",
  "CLP_lastUpdate": "Senaste uppdateringen",
  "CLP_completed": "avslutad",
  "CLP_incomplete": "ofullständig",
  "LanguagesDropdown_Languages": "Språk",
  "login_welcome_message": "Välkommen till Accessibility Management Systemet 👋",
  "CLP_Checklist_is_generated_based": "Checklistan genereras baserat på tillgänglighetsdata som vi samlar in från din anläggning. Den visar förbättringsområdena och när du väl bockat av punkten uppdateras svaret automatiskt i systemet och din tillgänglighetsdata kommer att ändras. Dokumentet kan laddas ner för externt bruk. För mer information",
  "CLP_Go_to_checklist": "Gå till checklistan",
  "CLP_Updated_date": "Uppdaterat datum",
  "CLP_The_purpose_of_Handiscover_1": "Syftet med Handiscovers inventering och checklista är att vägleda dig när du förbättrar din tillgänglighet. Den bifogade listan består av flera punkter. Ur perspektivet att något ska vara tillgänglighetsanpassat finns det punkter som är obligatoriska. Dessutom identifierar vi punkter som vi rekommenderar om man ska bygga nytt eller renovera.",
  "CLP_List_points": "Listpunkter",
  "CLP_Priority": "Prioritet",
  "CLP_User": "Användare",
  "CLP_Mandatory": "Obligatorisk",
  "CLP_Need_help": "Behöver du hjälp? Kontakta vårt team",
  "CLP_Handiscovers_suggestions": "Handiscovers förslag",
  "propertyForm_nextStep_tooltip": "Fyll i alla obligatoriska fält först",
  "statsPage_See_photos": "Se bilder",
  "statsPage_Your_subscription": "Ditt abonnemang",
  "statsPage_Filter_data_from": "Filtrera data från",
  "statsPage_Filter_data_to": "Filtrera data till",
  "statsPage_to": "till",
  "statsPage_Reload": "Ladda om",
  "statsPage_Business_Metrics": "Administrativ",
  "statsPage_Service_Metrics": "Tjänster",
  "statsPage_Statistics_page": "Statistiksida",
  "imagesPage_Pictures_List": "Bild lista",
  "imagesPage_Search_by_name": "Sök på namn",
  "imagesPage_No_pictures_available": "Inga bilder tillgängliga",
  "imagesPage_Name": "Namn",
  "imagesPage_Display_in_widget": "Visa i widget",
  "imagesPage_Type": "Typ",
  "imagesPage_Update_date": "Uppdatera datum",
  "imagesPage_Mandatory": "Obligatorisk",
  "imagesPage_Are_your_sure": "Är du säker?",
  "imagesPage_Delete": "Radera",
  "imagesPage_Yes": "Ja",
  "imagesPage_Cancel": "Avbryt",
  "imagesPage_Open_image": "Öppna bild",
  "imagesPage_Edit": "Redigera",
  "imagesPage_Delete_image": "Radera bild",
  "CLP_The_purpose_of_Handiscover_2": "Vi har även tagit med punkter som är \"enkla\" att fixa men viktiga ur ett tillgänglighetsperspektiv.",
  "a11yUnits_The_title_has_been_translated": "Titeln har översatts",
  "statsPage_Statistics": "Statistik",
  "customerSupportPage_thankYou": "Tack!",
  "customerSupportPage_requestSuccessfully": "Din förfrågan har skickats. Vår kundsupport tar hand om din förfrågan och återkommer till dig så snart som möjligt.",
  "customerSupportPage_warning": "Varning",
  "customerSupportPage_error": "Fel",
  "propertyListPage_showAll": "Visa allt",
  "propertyListPage_completed": "Avslutad",
  "propertyListPage_incomplete": "Ofullständig",
  "dashboard": "Administrationspanel",
  "widget": "Widget",
  "property_type": "Anläggningstyp",
  "category": "Kategori",
  "edit_widget": "Redigera widget",
  "created": "Skapat",
  "published": "Publicerat",
  "unpublished": "Opublicerad",
  "widget_info": "Tillgänglighetswidgeten visar detaljerad tillgänglighetsdata som tidigare loggats i tillgänglighetshanteringssystemet. Denna widget gör det möjligt att skapa bättre förutsättningar för besökarna att planera sin vistelse i förväg genom att se tillgängligheten som finns. Tillgänglighetswidgeten är interaktiv eftersom all data som uppdateras i systemet återspeglas i widgeten.",
  "view_live_widget": "Visa live-widget",
  "no_widget_data_message": "Vi har inga widgetdata. Vänligen kontakta vår kundtjänst.",
  "image_list": "Bildlista",
  "language_setting": "Språkinställning",
  "history": "Historik",
  "select_accessibility_unit": "Välj tillgänglighetsenhet",
  "add_new_image": "Lägg till ny bild",
  "order": "Ordning",
  "image": "Bild",
  "description": "Beskrivning",
  "accessibility_unit": "Tillgänglighetsenhet",
  "accessibility": "Tillgänglighet",
  "displayed_in_widget": "Visas i widget",
  "current_image": "Aktuell bild",
  "upload_new_picture": "Ladda upp ny bild",
  "image_description": "Bildbeskrivning",
  "image_order": "Bildordning",
  "back_to_list": "Tillbaka till listan",
  "no_picture": "Ingen bild",
  "please_write_the_text_in": "Skriv gärna in texten",
  "yes_delete": "JA, RADERA",
  "delete_warning_text": "Om du gör detta försvinner objektet från widgeten och standarden kommer automatiskt att uppdateras med ändringen.",
  "select_language_the_widget_provide": "Välj språk som widgeten tillhandahåller",
  "changed_by": "Ändrad av",
  "activity": "Aktivitet",
  "showing": "Visar",
  "of": "av",
  "items": "objekt",
  "questionnaire": "Frågeformulär",
  "we_are_showing_followings": "Vi visar följande i din Widget",
  "we_are_recommended_to_state": "Vi rekommenderas att ange viss praktisk information i widgeten för besökare till din egendom. Om du vill redigera den, vänligen kontakta vår kundtjänst",
  "select_what_you_want_to_show": "Välj vad du vill visa i widgeten",
  "practical_information": "Praktisk information",
  "you_can_add_maximum": "Du kan lägga till högst 3 meningar",
  "for_the_best_experiences_in_widget": "För bästa upplevelse i widgeten kommer vi att hjälpa dig om du önskar att lägga till mer information",
  "if_you_do_this_the_item_will_disappear": "Om du gör detta kommer objektet att försvinna från widgeten",
  "you_can_write_free_texts": "Du kan skriva fria texter att lägga till i den allmänna informationen om det behövs. Max 40 tecken",
  "write_a_new_information": "Skriv en ny information",
  "you_can_drag_and_drop_the_block": "Du kan dra och släppa blocket för att ändra beställningarna. Markera kryssrutan för att presentera i widgeten.",
  "you_can_freely_change_the_images_ordering": "Du kan fritt ändra bildordningen genom att dra och släppa.",
  "preview": "Förhandsvisning",
  "add_point_on_map": "Lägg till punkt på kartan",
  "LanguagesDropdown_Spanish": "spanska",
  "LanguagesDropdown_Norwegian": "norska",
  "LanguagesDropdown_Portuguese": "Portugisiska",
  "LanguagesDropdown_Ukrainian": "Ukrainska",
  "main_unit_image": "Bild(er) på huvudenhet",
  "item_pictures": "Artikelbilder",
  "please_choose_a_main_unit_image": "Välj en bild av huvudenheten",
  "please_choose_a_item_picture": "Vänligen välj en artikelbild",
  "button_settings_updated": "Knappinställningarna har uppdaterats framgångsrikt",
  "button_settings_created": "Knappinställningarna har skapats framgångsrikt",
  "button_settings": "Inställningar för knappar",
  "webmaster_instruction": "Instruktioner för webbansvariga",
  "contract_has_expired": "Ditt kontrakt har löpt ut. Widgeten har stängts av. Kontakta supporten",
  "webmaster_instructions_are_not_available": "Instruktioner för webbansvariga är inte tillgängliga för tillfället. Kontakta support",
  "create_api_key": "Skapa API-nyckel för detta företag",
  "standard_instruction": "Standardinstruktion",
  "google_tag_manager_instruction": "Instruktioner för Google Tag Manager"
}